import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import { CustomInput } from 'reactstrap';

const Checkbox = (props) => {
  let [, meta, helper] = useField(props),
    { name, value, label, readOnly, ...other } = props;

  return (
    <CustomInput
      id={`${name}_${value}`}
      type='checkbox'
      name={`${name}${value}`}
      value={value}
      label={label}
      onChange={(e) => {
        if (meta.value === value) helper.setValue('', true);
        else helper.setValue(value, true);
      }}
      checked={meta.value === value}
      disabled={readOnly}
      invalid={meta.error && meta.touched}
      {...other}
    />
  );
};

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default Checkbox;
